module.exports = __webpack_public_path__ + "static/media/study 220518.67057d8e.png";